module.exports = __webpack_public_path__ + "img/DSC08964.584cad95.webp";